import React from 'react';
import './Product.scss';

const Product = ({product, addToCardHandler, addToWishlistHandler, addFreeToCardHandler}) => {
    const price = parseFloat(product.price).toFixed(2);
    return (
        <div className="product-item">
            <div style={{color: "red"}}>
            </div>
            <div className="img">
                <a href={process.env.REACT_APP_URL + '/' + product.keyword}>
                    <img src={process.env.REACT_APP_URL + '/image/' + product.image} alt="img"/>
                </a>
            </div>
            <div className="product-item--content">

                {price === '0.00' ? (
                    <div className="price">FREE</div>
                ) : (
                    <div className="price">{"$" + price}</div>
                )}

                <div className="name">
                    <a href={process.env.REACT_APP_URL + '/' + product.keyword}>{product.name}</a>
                </div>
                <div className="description">{product.description}</div>
                <div className="cart">
                    {price === '0.00' ? (
                        <button className="btn btn-add" onClick={() => addFreeToCardHandler(product.product_id)}>Get it!
                        </button>) : (
                        <button className="btn btn-add" onClick={() => addToCardHandler(product.product_id)}>Add to cart
                        </button>)}
                    <button className="btn btn-star" onClick={() => addToWishlistHandler(product.product_id)}></button>
                </div>
                <div className="cart-types">
                    {product.type === 'regular' && (
                        <div className="project-type standart">Standard</div>
                    )}
                    {product.type === 'subscription' && (
                        <div className="project-type subscription">Subscription</div>
                    )}
                    {product.is_streaming === '1' && (
                        <div className="project-type streaming">Streaming</div>
                    )}
                    {product.is_free === '1' && (
                        <div className="project-type free">Free</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Product;
